import { useMediaQuery } from "@mui/material";
import React from "react";
import { PageModule } from "@/components/PageModule";
import {
  PressTestimonials,
  Testimonial,
} from "@/features/testimonials/PressTestimonials";
import { theme } from "@/theme";

export interface PressModuleProps {
  testimonials: Testimonial[];
}
export const PressModule = ({ testimonials }: PressModuleProps) => {
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const quotedTestimonials = testimonials.map((t) => ({
    ...t,
    content: `“${t.content}”`,
  }));
  return (
    <PageModule className={`${isSmallScreen ? "px-0" : ""} py-0`}>
      <PressTestimonials testimonials={quotedTestimonials} />
    </PageModule>
  );
};
